import { render, staticRenderFns } from "./query.vue?vue&type=template&id=5722f712&scoped=true&"
import script from "./query.vue?vue&type=script&lang=js&"
export * from "./query.vue?vue&type=script&lang=js&"
import style0 from "./query.vue?vue&type=style&index=0&id=5722f712&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722f712",
  null
  
)

export default component.exports